import { useState } from "react";
import { T } from "@/components/T";
import { Link } from "react-router-dom";
import { AuthShell } from "@/pages/Login";
import { requestPasswordReset } from "@/lib/api";

const inputCls = "w-full border border-line bg-parchment px-4 py-2.5 text-ink focus:border-saffron focus:outline-none";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await requestPasswordReset(email.trim());
      setMessage(data.message || "If an account exists for that email, we've sent a reset link.");
      setSent(true);
    } catch {
      setMessage("If an account exists for that email, we've sent a reset link.");
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Forgot password" subtitle="We'll email you a secure reset link">
      {sent ? (
        <div className="space-y-5 text-center" data-testid="forgot-sent">
          <p className="text-4xl text-saffron" aria-hidden="true">ॐ</p>
          <p className="text-sm text-ink-2">{message}</p>
          <p className="text-xs text-ink-3"><T>The link is valid for 1 hour. Remember to check your spam folder.</T></p>
          <Link to="/login" className="inline-block text-sm text-saffron link-underline" data-testid="forgot-back-login"><T>Back to sign in</T></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1.5 block text-sm text-ink-2"><T>Email</T></label>
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@example.com" />
          </div>
          <button data-testid="forgot-submit" disabled={busy} className="w-full bg-[var(--saffron)] py-3 font-medium text-white transition-colors hover:bg-[var(--saffron-dark)] disabled:opacity-60">
            {busy ? "Sending…" : "Send reset link"}
          </button>
          <p className="text-center text-sm text-ink-3">
            <T>Remembered it?</T> <Link to="/login" className="text-saffron link-underline"><T>Sign in</T></Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
